import { Fragment, useRef, useState } from "react"
import { Card, Spinner } from "react-bootstrap"
import { useSelector } from "react-redux"

import './BodyRow.scss'
import { valorMoeda, locationDev, correctDataUTC, deleteData } from "../../../services/Servicos"
import ModalEditarRowTransportadora from "../../modal/ModalEditarRowTransportadora"
import ModalErrorPretty from "../../modal/ModalErrorPretty"

export default function BodyRowTransportadora({ headList, bodyList, index, setEditarTransportadora = () => {}, tableLength, restartData}) {

   const refRow = useRef(null)
    const refEditar = useRef(null)
    const user = useSelector(state => state.userSlice)
    const filiaisList = user.filiaisList.data 
    const [error, setError] = useState({
        show: false,
        message: '',
    })
    const [editarRow, setEditarRow] = useState({
        flag: false,
    })
    const onClickEditarRow = (e) => {
        setEditarRow({
            show: true,
            body: bodyList,
        })
    }

    const onClickTableRow = (e) => {
        e.preventDefault()
        refRow.current.classList = 'bg-selected'
        let refRowNumber = index

        let i = refRowNumber
        let actualSibling = refRow.current.nextSibling

        while(i < tableLength){
            if(actualSibling === null){
                break
            }
            actualSibling.classList = ''
            
            actualSibling = actualSibling.nextSibling
            i++
        }

        i = refRowNumber
        let actualSiblingPrevious = refRow.current.previousSibling

        while(i > 0){
            if(actualSiblingPrevious === null){
                break
            }
            actualSiblingPrevious.classList = ''
            
            actualSiblingPrevious = actualSiblingPrevious.previousSibling
            i--
        }
    }

    return (
        <Fragment>
            {
                <tr
                    ref={refRow}
                    onClick={onClickTableRow}
                >
                    {
                        headList.map((item, _index) => {
                            if (item === 'index') { /* primary key can not be modified */

                                return <td key={_index} className={item}>
                                    <b>{index + 1}</b>
                                </td>

                            } else if (item === 'admin') { /* primary key can not be modified */

                                return <td key={_index} className={item}>
                                    <i className="bi bi-pencil-fill" onClick={onClickEditarRow}></i>
                                </td>

                            }
                            else if (item === 'ativo' || item === 'status' || item === 'confirmado' || item === 'integrado' || item === 'romaneio' || item === 'is_3pl' || item === 'loggiIntegrado' || item === 'agendado') { /* primary key can not be modified */

                                return bodyList[item] ?
                                    <td key={_index} className={item}>
                                        <div className="div-status">
                                            <span className="div-status-ativo">Ativo</span>
                                        </div>
                                    </td> : <td key={_index} className={item}>
                                        <div className="div-status">
                                            <span className="div-status-inativo">Inativo</span>
                                        </div>
                                    </td>

                            } 
                            else if (item.includes('valor')) { /* primary key can not be modified */

                                return <td key={_index} style={{minWidth:'10rem'}}>{valorMoeda(bodyList[item])}</td>

                            }
                            else if (item === 'data') { /* primary key can not be modified */

                                return <td key={_index} style={{minWidth:'10rem'}}>{bodyList[item]}</td>

                            }
                            else if (item === 'created_at' || item === 'updated_at') { /* primary key can not be modified */

                                return <td key={_index} className={item}> {correctDataUTC(bodyList[item])}</td>

                            }
                            else if (item === 'id_filial') {
                                return <td key={_index}>{filiaisList.filter(item => item.idFilial == bodyList.id_filial)[0]?.identificacaoInterna ?? 'NÃO INFORMADO'}</td>
                            } 
                            return <td key={_index} className={item}> {bodyList[item]}</td>
                        })
                    }
                </tr>
            }
            
			{editarRow.show ? (
				<ModalEditarRowTransportadora
					setShow={setEditarRow}
					{...editarRow}
				/>
			) : (
				""
			)}
            {error.show ? (
                <ModalErrorPretty {...error} setShow={setError}/>
            ) : ''}
        </Fragment>
    )
}
